module.exports = __webpack_public_path__ + "static/media/s_biathlon.0b8704e3.mp3";